function presentSecretState(value: { configured?: boolean; fingerprint?: string | null }) {
  if (!value?.configured) {
    return 'Ключ не задано';
  }

  return value.fingerprint
    ? `Ключ збережено · контрольний код ${value.fingerprint}`
    : 'Ключ збережено';
}

function presentEnumValue(value: string) {
  const labels: Record<string, string> = {
    active: 'Активний',
    admin: 'Адмін',
    completed: 'Завершено',
    disabled: 'Вимкнений',
    doors: 'З адреси магазину',
    failed: 'Помилка',
    full_catalog_dev: 'Тестова повна синхронізація',
    live: 'Бойовий режим',
    managed_scope_live: 'Керований каталог з 1С',
    manual: 'Тільки вручну',
    after_payment: 'Після успішної онлайн-оплати',
    Cargo: 'Вантаж',
    Cash: 'Готівка',
    Documents: 'Документи',
    NonCash: 'Безготівковий',
    on_order_create: 'Одразу після створення замовлення',
    Pallet: 'Палети',
    Parcel: 'Посилка',
    pending: 'Очікує',
    Recipient: 'Одержувач',
    running: 'Виконується',
    safe_live_rollout: 'Обережне оновлення каталогу',
    sandbox: 'Тестовий режим',
    Sender: 'Відправник',
    TiresWheels: 'Шини-диски',
    viewer: 'Перегляд',
    warehouse: 'З відділення Нової Пошти',
  };

  return labels[value] || humanizeTechnicalLabel(value);
}

export function presentSettingsFieldLabel(key: string) {
  const labels: Record<string, string> = {
    'Batch черги замовлень': 'Кількість замовлень за прохід',
    'Dry run': 'Тест без запису в Shopify',
    LIQPAY_LIVE_PRIVATE_KEY: 'Бойовий приватний ключ LiqPay',
    LIQPAY_LIVE_PUBLIC_KEY: 'Бойовий публічний ключ LiqPay',
    LIQPAY_MODE: 'Режим LiqPay',
    LIQPAY_PRIVATE_KEY: 'Приватний ключ LiqPay',
    LIQPAY_PUBLIC_KEY: 'Публічний ключ LiqPay',
    LIQPAY_SANDBOX_PRIVATE_KEY: 'Тестовий приватний ключ LiqPay',
    LIQPAY_SANDBOX_PUBLIC_KEY: 'Тестовий публічний ключ LiqPay',
    'Live private key': 'Бойовий приватний ключ LiqPay',
    'Live public key': 'Бойовий публічний ключ LiqPay',
    NOVA_POSHTA_API_KEY: 'API ключ Нової Пошти',
    NOVA_POSHTA_API_URL: 'Адреса API Нової Пошти',
    NOVA_POSHTA_CARGO_TYPE: 'Тип вантажу',
    NOVA_POSHTA_COD_ENABLED: 'Післяплата на пошті',
    NOVA_POSHTA_DEFAULT_COST_CENTS: 'Оціночна вартість',
    NOVA_POSHTA_DEFAULT_DESCRIPTION: 'Опис вантажу',
    NOVA_POSHTA_DEFAULT_HEIGHT_CM: 'Висота, см',
    NOVA_POSHTA_DEFAULT_LENGTH_CM: 'Довжина, см',
    NOVA_POSHTA_DEFAULT_SEATS_AMOUNT: 'Кількість місць',
    NOVA_POSHTA_DEFAULT_WEIGHT_KG: 'Вага за замовчуванням',
    NOVA_POSHTA_DEFAULT_WIDTH_CM: 'Ширина, см',
    NOVA_POSHTA_DELIVERY_BRANCH_ENABLED: 'Відділення',
    NOVA_POSHTA_DELIVERY_COURIER_ENABLED: 'Курʼєр на адресу',
    NOVA_POSHTA_DELIVERY_PAYER_TYPE: 'Платник доставки',
    NOVA_POSHTA_DELIVERY_POSTOMAT_ENABLED: 'Поштомат',
    NOVA_POSHTA_FALLBACK_BRANCH_PRICE_CENTS: 'Fallback відділення',
    NOVA_POSHTA_FALLBACK_COURIER_PRICE_CENTS: 'Fallback курʼєр',
    NOVA_POSHTA_FALLBACK_POSTOMAT_PRICE_CENTS: 'Fallback поштомат',
    NOVA_POSHTA_FREE_SHIPPING_THRESHOLD_CENTS: 'Безкоштовна доставка від',
    NOVA_POSHTA_PAYMENT_METHOD: 'Форма оплати доставки',
    NOVA_POSHTA_PRICE_CACHE_ENABLED: 'Кеш тарифів доставки',
    NOVA_POSHTA_PRICE_CACHE_STALE_MINUTES: 'Резерв кешу тарифів',
    NOVA_POSHTA_PRICE_CACHE_TTL_MINUTES: 'Актуальність кешу тарифів',
    NOVA_POSHTA_SENDER_DISPATCH_TYPE: 'Звідки відправляємо',
    NOVA_POSHTA_SENDER_ADDRESS_REF: 'Адреса відправника',
    NOVA_POSHTA_SENDER_CITY_REF: 'Місто відправника',
    NOVA_POSHTA_SENDER_CONTACT_REF: 'Контакт відправника',
    NOVA_POSHTA_SENDER_PHONE: 'Телефон відправника',
    NOVA_POSHTA_SENDER_REF: 'Відправник',
    NOVA_POSHTA_TIMEOUT_MS: 'Timeout API Нової Пошти',
    NOVA_POSHTA_TTN_AUTO_RETRY_FAILED_BATCH_SIZE: 'Batch автоповтору помилок',
    NOVA_POSHTA_TTN_AUTO_RETRY_FAILED_DELAY_MINUTES: 'Затримка автоповтору помилок',
    NOVA_POSHTA_TTN_AUTO_RETRY_FAILED_ENABLED: 'Автоповтор помилок ТТН',
    NOVA_POSHTA_TTN_AUTO_RETRY_FAILED_MAX_AGE_HOURS: 'Макс. вік помилки для автоповтору',
    NOVA_POSHTA_TTN_CREATION_MODE: 'Коли створювати ТТН',
    NOVA_POSHTA_TTN_DRY_RUN: 'Тест без створення ТТН',
    NOVA_POSHTA_TTN_ENABLED: 'Створення ТТН',
    NOVA_POSHTA_WAREHOUSE_BRANCH_ENABLED: 'Поштове відділення',
    NOVA_POSHTA_WAREHOUSE_CARGO_ENABLED: 'Вантажне відділення',
    NOVA_POSHTA_WAREHOUSE_LIMITED_BRANCH_ENABLED: 'Відділення з обмеженням',
    NOVA_POSHTA_WAREHOUSE_POSTOMAT_ENABLED: 'Поштомат',
    NOVA_POSHTA_WAREHOUSE_PRIVATBANK_POSTOMAT_ENABLED: 'Поштомат ПриватБанку',
    ONEC_CREATE_PRODUCTS: 'Створювати нові товари',
    ONEC_CREATE_VARIANTS: 'Створювати нові розміри',
    ONEC_DRAFT_PUBLISH_RECHECK_INTERVAL_MINUTES: 'Інтервал перевірки чернеток',
    ONEC_DRY_RUN: 'Безпечний режим без запису',
    ONEC_ENABLE_ARCHIVE_PASS: 'Прибирати неактуальні товари',
    ONEC_ENABLE_DRAFT_PUBLISH_RECHECK: 'Перевірка чернеток',
    ONEC_ENABLE_SYNC_ORDERS: 'Передавати замовлення в 1С',
    ONEC_ENABLE_VARIANT_LIFECYCLE_SYNC: 'Оновлювати видимість розмірів',
    ONEC_QUEUED_ORDERS_BATCH_SIZE: 'Кількість замовлень за прохід',
    ONEC_QUEUED_ORDERS_INTERVAL_MINUTES: 'Інтервал черги замовлень',
    ONEC_SYNC_INTERVAL_MINUTES: 'Інтервал повної синхронізації',
    ONEC_SYNC_MODE: 'Режим синхронізації каталогу',
    ONEC_SYNC_PRODUCT_STATUS_FROM_VARIANTS: 'Оновлювати статус товарів',
    ONEC_SYNC_RETRY_MINUTES: 'Повтор після помилки',
    'Retry після помилки': 'Повтор після помилки',
    'Sandbox private key': 'Тестовий приватний ключ LiqPay',
    'Sandbox public key': 'Тестовий публічний ключ LiqPay',
    SCHEDULER_ENABLED: 'Автоматична синхронізація',
    TELEGRAM_BOT_TOKEN: 'Ключ Telegram бота',
    TELEGRAM_MINI_APP_URL: 'Адреса Telegram Mini App',
    TELEGRAM_WEBHOOK_URL: 'Адреса подій Telegram',
    configured: 'стан',
    fingerprint: 'відбиток',
    label: 'назва',
    mode: 'режим',
    privateKeyConfigured: 'приватний ключ',
    privateKeyFingerprint: 'відбиток приватного ключа',
    publicKeyConfigured: 'публічний ключ',
    publicKeyFingerprint: 'відбиток публічного ключа',
    role: 'роль',
    status: 'статус',
  };

  return labels[key] || humanizeTechnicalLabel(key);
}

export function presentSettingsPreviewFieldLabel(entry: { key?: string | null; label?: string | null }) {
  const label = typeof entry?.label === 'string' ? entry.label.trim() : '';
  if (label && label !== entry?.key) {
    return label;
  }

  return presentSettingsFieldLabel(entry?.key || label || '');
}

function canInlineObjectValue(value: unknown) {
  return value === null ||
    value === undefined ||
    ['string', 'number', 'boolean'].includes(typeof value);
}

function humanizeTechnicalLabel(value: string) {
  return String(value || '—')
    .replace(/[_-]+/g, ' ')
    .replace(/\bONEC\b/g, '1С')
    .replace(/\bLIQPAY\b/g, 'LiqPay')
    .replace(/\bURL\b/g, 'адреса')
    .replace(/\bAPI\b/g, 'API')
    .replace(/\s+/g, ' ')
    .trim();
}

function presentCredentialPart(configured?: boolean, fingerprint?: string | null) {
  if (!configured) return 'не задано';
  return fingerprint ? `збережено · контрольний код ${fingerprint}` : 'збережено';
}

function presentPaymentProfile(value: Record<string, unknown>) {
  const configured = Boolean(value.configured);
  const publicConfigured = Boolean(value.publicKeyConfigured);
  const privateConfigured = Boolean(value.privateKeyConfigured);
  const publicFingerprint = typeof value.publicKeyFingerprint === 'string' ? value.publicKeyFingerprint : null;
  const privateFingerprint = typeof value.privateKeyFingerprint === 'string' ? value.privateKeyFingerprint : null;

  return [
    configured ? 'Пара ключів повна' : 'Пара ключів неповна',
    `публічний: ${presentCredentialPart(publicConfigured, publicFingerprint)}`,
    `приватний: ${presentCredentialPart(privateConfigured, privateFingerprint)}`,
  ].join(' · ');
}

function presentActivePaymentProfile(value: Record<string, unknown>) {
  const mode = typeof value.mode === 'string' ? presentEnumValue(value.mode) : 'Невідомий профіль';
  const configured = value.configured === true ? 'пара ключів повна' : 'пара ключів неповна';
  return `${mode} · ${configured}`;
}

export function presentSettingsTarget(target: string) {
  if (target === 'pay-web') return 'Оплати і checkout';
  if (target === 'onec-worker') return 'Каталог і замовлення з 1С';
  if (['telegram', 'telegram-mini-app', 'telegram-runtime'].includes(target)) {
    return 'Telegram Mini App';
  }
  return target.replace(/[_-]+/g, ' ');
}

export function presentChangeKind(linked: boolean) {
  return linked
    ? 'Підтягнеться разом із пов’язаними пунктами'
    : 'Зміниться тільки цей пункт';
}

export function presentDependencyMessage(message: string) {
  const labels: Record<string, string> = {
    'Archive pass requires ONEC_SYNC_MODE=managed_scope_live':
      'Автоматичне прибирання неактуальних товарів працює тільки в основному режимі керування каталогом з 1С.',
    'Cannot reload onec-worker while a sync is running':
      'Зараз триває синхронізація каталогу. Дочекайтеся завершення і повторіть спробу.',
    'Draft publish recheck interval must be at least 5 minutes':
      'Інтервал перевірки чернеток має бути не менше 5 хвилин.',
    'Live LiqPay mode requires live public/private keys':
      'Щоб увімкнути реальні оплати, потрібна повна бойова пара ключів LiqPay.',
    'LiqPay will remain in sandbox mode':
      'Після цього кроку оплати все одно лишаться тестовими, доки ви окремо не увімкнете бойовий режим.',
    'ONEC_DRY_RUN=true keeps Shopify writes disabled':
      'Зараз увімкнений тестовий режим без запису, тому сайт не отримає реальних змін.',
    'Product status sync requires variant lifecycle sync':
      'Щоб оновлювати статус товару автоматично, треба також увімкнути оновлення доступності розмірів.',
    'Queued order interval must be at least 5 minutes':
      'Інтервал перевірки черги замовлень має бути не менше 5 хвилин.',
    'Settings file changed since preview':
      'Після перевірки ці налаштування вже змінилися. Оновіть сторінку і перевірте ще раз.',
    'managed_scope_live requires ONEC_CREATE_PRODUCTS=true':
      'Основний режим каталогу з 1С вимагає автоматичного додавання нових товарів на сайт.',
    'managed_scope_live requires ONEC_CREATE_VARIANTS=true':
      'Основний режим каталогу з 1С вимагає автоматичного додавання нових розмірів.',
    'managed_scope_live requires ONEC_ENABLE_VARIANT_LIFECYCLE_SYNC=true':
      'Основний режим каталогу з 1С вимагає автоматичного оновлення доступності товарів і розмірів.',
    'Sandbox LiqPay mode has no sandbox key pair configured':
      'Для тестових оплат ще не задано повну тестову пару ключів LiqPay.',
  };

  if (labels[message]) {
    return labels[message];
  }

  const validationMatch = message.match(/^Setting\s+([A-Z0-9_]+)\s+(.*)$/u);
  if (validationMatch) {
    const label = presentSettingsFieldLabel(validationMatch[1]);
    const rule = validationMatch[2];

    if (rule.startsWith('is not editable')) {
      return `${label}: цей пункт не можна змінити в цьому розділі.`;
    }

    if (rule.startsWith('has invalid value')) {
      return `${label}: введене значення некоректне.`;
    }

    if (rule.startsWith('must be one of')) {
      return `${label}: оберіть один із доступних варіантів.`;
    }

    const minMatch = rule.match(/^must be >=\s+(.+)$/u);
    if (minMatch) {
      return `${label}: значення має бути не менше ${minMatch[1]}.`;
    }

    const maxMatch = rule.match(/^must be <=\s+(.+)$/u);
    if (maxMatch) {
      return `${label}: значення має бути не більше ${maxMatch[1]}.`;
    }
  }

  if (/^Secret setting .+ is not available/u.test(message)) {
    return 'Цей секретний ключ недоступний для вибраного розділу.';
  }

  if (/^Unsupported settings target/u.test(message)) {
    return 'Цей розділ налаштувань не підтримується.';
  }

  if (/ECONNREFUSED|ECONNRESET|ETIMEDOUT|fetch failed|Unable to reach/u.test(message)) {
    return 'Один із сервісів тимчасово недоступний. Спробуйте ще раз або зверніться до підтримки.';
  }

  if (/ENOENT|EACCES|\.env|PM2|ONEC_|LIQPAY_|SHOPIFY_|worker|preview|stack|TypeError|SyntaxError/u.test(message)) {
    return 'Потрібна технічна перевірка. Зміни не застосовано.';
  }

  return humanizeTechnicalLabel(message);
}

export function presentSettingsValue(value: unknown): string {
  if (value === null || value === undefined || value === '') {
    return 'Не задано';
  }

  if (typeof value === 'boolean') {
    return value ? 'Увімкнено' : 'Вимкнено';
  }

  if (typeof value === 'number') {
    return String(value);
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if ((trimmed.startsWith('{') && trimmed.endsWith('}')) || (trimmed.startsWith('[') && trimmed.endsWith(']'))) {
      try {
        return presentSettingsValue(JSON.parse(trimmed));
      } catch {
        return presentEnumValue(value);
      }
    }
    return presentEnumValue(value);
  }

  if (Array.isArray(value)) {
    if (value.length === 0) {
      return 'Порожній список';
    }

    if (value.every(canInlineObjectValue)) {
      return value.map((entry) => presentSettingsValue(entry)).join(', ');
    }

    return `Список із ${value.length} пунктів оновиться`;
  }

  if (typeof value === 'object') {
    const objectValue = value as Record<string, unknown>;
    if ('publicKeyConfigured' in objectValue || 'privateKeyConfigured' in objectValue) {
      return presentPaymentProfile(objectValue);
    }

    if ('mode' in objectValue && 'configured' in objectValue) {
      return presentActivePaymentProfile(objectValue);
    }

    const secretState = value as { configured?: boolean; fingerprint?: string | null };
    if ('configured' in secretState || 'fingerprint' in secretState) {
      return presentSecretState(secretState);
    }

    if (typeof objectValue.label === 'string') {
      return presentSettingsValue(objectValue.label);
    }

    const entries = Object.entries(objectValue);
    if (entries.length === 0) {
      return 'Не задано';
    }

    if (entries.length <= 4 && entries.every(([, entryValue]) => canInlineObjectValue(entryValue))) {
      return entries
        .map(([key, entryValue]) => `${presentSettingsFieldLabel(key)}: ${presentSettingsValue(entryValue)}`)
        .join(' · ');
    }

    return 'Пакет налаштувань оновиться';
  }

  return String(value);
}
